import React from 'react';
import { Gift } from 'lucide-react';

const Spinner: React.FC<{size?: number}> = ({ size = 24 }) => {
  const s = `${size}px`;
  return (
    <div role="status" aria-label="Loading" className="min-h-screen flex flex-col items-center justify-center gap-8 bg-gradient-warm">
      {/* App Logo */}
      <div className="relative animate-fade-in">
        <div className="absolute inset-0 bg-primary/20 blur-3xl rounded-full animate-pulse" />
        <div className="relative bg-gradient-sunset p-6 rounded-2xl shadow-warm">
          <Gift className="w-12 h-12 text-white" />
        </div>
      </div>
      
      {/* Spinner */}
      <div style={{ width: s, height: s }} className="rounded-full border-4 border-t-transparent animate-spin border-primary" />
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default Spinner;
